import React from "react";
import { TimesheetProvider } from "./timesheet";

const withTimesheetProvider = <P extends object>(
  Component: React.ComponentType<P>
): React.FC<P> => {
  const WrappedComponent: React.FC<P> = (props: P) => (
    <TimesheetProvider>
      <Component {...props} />
    </TimesheetProvider>
  );

  WrappedComponent.displayName = `withTimesheetProvider(${
    Component.displayName || Component.name || "Component"
  })`;

  return WrappedComponent;
};

export default withTimesheetProvider;
